const projects = [
    {
        name: "Calculator",
        image: require("../assets/images/calculator.jfif"),
        description: "A javascript Calculator that support equations",
        tech: [
            "HTML","CSS","JS"
        ],
        code: "https://github.com/tejasrana1/calculator",
        demo: "https://tejasrana1.github.io/calculator/"

    },
    {
        name: "Tambola",
        image: require("../assets/images/tambola.jfif"),
        description: "A tambola generator which can also generate tickets",
        tech: ["HTML","CSS","JS"],
        code: "https://github.com/tejasrana1/tambola",
        demo: "https://tejasrana1.github.io/tambola/"
        
    },
    {
        name: "Drum Kit",
        image: require("../assets/images/drumkit.jfif"),
        description: "A drum kit that makes sound on key/mouse press",
        tech: ["HTML","CSS","JS"],
        code: "https://github.com/tejasrana1/drumKit",
        demo: "https://tejasrana1.github.io/drumKit/"
        
    },
    {
        name: "Tic Tac Toe",
        image: require("../assets/images/tictactoe.jfif"),
        description: "A tic tac toe game for 2 players",
        tech: ["HTML","CSS","JS"],
        code: "https://github.com/tejasrana1/tictactoe",
        demo: "https://tejasrana1.github.io/tictactoe/"
        
    },
    {
        name: "SDMS",
        image: require("../assets/images/sdms.jpg"),
        description: "A Database Management System for Students",
        tech: ["HTML","CSS","JS","NodeJs","ExpressJs"],
        code: "https://github.com/tejasrana1/sdms",
        demo: "https://piscine-mandarine-33551.herokuapp.com/"
        
    },
    {
        name: "ExpressJet",
        image: require("../assets/images/expressjet.jfif"),
        description: "A Social Media Site which focuses on growth of individual",
        tech: ["Mongodb", "ExpressJs","ReactJs","NodeJs"],
        code: "https://github.com/tejasrana1/expressjet",
        demo: "https://expressjet.netlify.app/"
        
    },
    {
        name: "Sorting-Visualizer",
        image: require("../assets/images/sorting.png"),
        description: "A Visualizer which visualises different sorting algorithms",
        tech: ["ReactJs"],
        code: "https://github.com/tejasrana1/sorting-visualizer",
        demo: "https://sortalgo-visualizer.netlify.app/"
        
    },


]


export default projects;